const atmosSettings = document.atmosSettings;

export const OidcSettings = {
  authority: `https://sentry-${atmosSettings.environment}.softpro.io`,
  client_id: 'atmos.web',
  redirect_uri: `${atmosSettings.baseUrl.replace(/\/$/, "")}/auth`,
  silent_redirect_uri: `${atmosSettings.baseUrl.replace(/\/$/, "")}/silent-renew`,
  post_logout_redirect_uri: `${atmosSettings.baseUrl.replace(/\/$/, "")}/dashboard`,
  automaticSilentRenew: true,
  response_type: 'id_token token',
  scope: 'openid atmos email',
  clockSkew: 900
}
